
import { createContext, useContext, useState, ReactNode } from 'react';

interface UserNameContextType {
  userName: string;
  setUserName: (name: string) => void;
}

const UserNameContext = createContext<UserNameContextType | undefined>(undefined);

export function UserNameProvider({ children }: { children: ReactNode }) {
  const [userName, setUserName] = useState<string>('');

  return (
    <UserNameContext.Provider value={{ userName, setUserName }}>
      {children}
    </UserNameContext.Provider>
  );
}

export function useUserName() {
  const context = useContext(UserNameContext);
  if (context === undefined) {
    throw new Error('useUserName must be used within a UserNameProvider');
  }
  return context;
}
